import React from 'react'
import { Selector } from '../../../../types'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { ButtonComponent } from '../../../common/Button'

export function PipelineStepButton(props: { disabled?: boolean; callback: Function; selector: Selector }) {
  const { disabled, callback, selector } = props

  function callbackSelector() {
    callback(selector)
  }

  return (
    <ButtonComponent
      classNames='margin-right'
      disabled={disabled}
      callback={callbackSelector}
      text={selector.type + ':' + selector.pattern}
      icon={<OpenInNewIcon />}
    />
  )
}
